import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API_GET_WHITELABEL_COMPANY, API_WHITELABEL_COMPANY } from '../api/whitelabel';

export const saveWhiteLabelCompany = createAsyncThunk(
  'whitelabel/saveWhiteLabelCompany',
  async (formData, { rejectWithValue }) => {
    try {
      const data = await API_WHITELABEL_COMPANY(formData);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchWhiteLabelCompany = createAsyncThunk(
  'whitelabel/fetchWhiteLabelCompany',
  async (companyId, { rejectWithValue }) => {
    try {
      const data = await API_GET_WHITELABEL_COMPANY(companyId);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  companyData: null,
  loading: false,
  error: null,
};

const whiteLabelSlice = createSlice({
  name: 'whitelabel',
  initialState,
  reducers: {
    clearError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Save white-label company
      .addCase(saveWhiteLabelCompany.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveWhiteLabelCompany.fulfilled, (state, action) => {
        state.loading = false;
        state.companyData = action.payload;
      })
      .addCase(saveWhiteLabelCompany.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch white-label company
      .addCase(fetchWhiteLabelCompany.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWhiteLabelCompany.fulfilled, (state, action) => {
        state.loading = false;
        state.companyData = action.payload;
      })
      .addCase(fetchWhiteLabelCompany.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = whiteLabelSlice.actions;
export default whiteLabelSlice.reducer;
